import React, { useEffect, useRef } from 'react';
import './Space.css';

const Space = () => {
  const canvasRef = useRef(null);
  
  // Function to draw the stars
  const drawStars = (ctx, width, height) => {
    ctx.fillStyle = 'white';
    for (let i = 0; i < 500; i++) {
      // Create stars with different sizes for a more realistic effect
      const x = Math.random() * width;
      const y = Math.random() * height;
      const size = Math.random() * 2;
      
      // Randomly create some brighter stars
      if (Math.random() < 0.1) {
        ctx.shadowColor = 'white';
        ctx.shadowBlur = 10;
        ctx.beginPath();
        ctx.arc(x, y, size + 0.5, 0, Math.PI * 2);
        ctx.fill();
        ctx.shadowBlur = 0;
      } else {
        ctx.beginPath();
        ctx.arc(x, y, size, 0, Math.PI * 2);
        ctx.fill();
      }
    }
  };

  // Create a subtle twinkling effect
  const animateStars = () => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    
    const ctx = canvas.getContext('2d');
    
    // Clear canvas
    ctx.fillStyle = 'black';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Draw stars
    drawStars(ctx, canvas.width, canvas.height);
    
    // Create twinkling effect by changing some stars
    ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    
    // Request next frame
    requestAnimationFrame(animateStars);
  };
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    
    // Set canvas to full window
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    
    // Start animation
    animateStars();
    
    // Handle window resize
    const handleResize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  return (
    <div className="space-container">
      <canvas ref={canvasRef} className="space-canvas"></canvas>
    </div>
  );
};

export default Space; 